module.exports = __webpack_public_path__ + "img/headline.73800fb1.png";